// EXPERIMENT #171270395
/* eslint-disable jsx-a11y/click-events-have-key-events */

import React from 'react';
import PropTypes from 'prop-types';
import { hot } from 'react-hot-loader';

import Modal from 'components/modal';
import toggleModalVisibility from 'components/survey_signup_modal/visibility';
import SurveyManager from './components/survey_manager';
import LPSurveyManager from './components/lp_survey_manager';
import { SignupForm } from './components/signup_form';
import CompanyLeadShape from './constants/CompanyLeadShape';
import { getAnswersFromStorage, storeAnswerToStorage } from './storage_helpers';

import 'survey_signup_modal.scss';

const CloseIcon = () => (
  <div className="close absolute" onClick={toggleModalVisibility} role="button" tabIndex="0">
    <p className="text-xlarge margin-bottom-none padding-right-10px c-salt-500">&#x00d7;</p>
  </div>
);

class SurveySignupModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showSignupForm: false,
    };
  }

  onSurveyFinish = () => {
    this.setState({ showSignupForm: true });
  };

  onModalClose = () => {
    // Reset state on modal close
    if (this.state.showSignupForm) {
      this.setState({ showSignupForm: false });
    }
  };

  getContractorOnly = () => {
    const surveyAnswers = getAnswersFromStorage();
    return surveyAnswers.WORKERS_TYPE === 'contractor_only';
  };

  componentDidMount() {
    storeAnswerToStorage('companyLead', this.props.companyLead);
  }

  componentDidUpdate() {
    // We dont render survey if modal is closed
    if (!this.props.renderSurvey) {
      this.onModalClose();
    }
  }

  render() {
    const {
      fromGoogleSSO,
      companyLead,
      renderSurvey,
      signupHeaderType,
      withIndustryIdentification,
      withRandomizedQuestion,
    } = this.props;

    return (
      <div className="d-flex justify-content-center">
        <Modal>
          <div className="padding-left-10px padding-right-10px padding-left-md-none padding-right-md-none">
            <CloseIcon />
            {!this.state.showSignupForm &&
              renderSurvey &&
              (signupHeaderType === 'landingPage' ? (
                <LPSurveyManager
                  onSurveyFinish={this.onSurveyFinish}
                  withRandomizedQuestion={withRandomizedQuestion}
                />
              ) : (
                <SurveyManager
                  onSurveyFinish={this.onSurveyFinish}
                  withIndustryIdentification={withIndustryIdentification}
                />
              ))}
            {this.state.showSignupForm && (
              <SignupForm
                contractorOnly={this.getContractorOnly()}
                fromGoogleSSO={fromGoogleSSO}
                companyLead={companyLead}
                headerType={signupHeaderType}
              />
            )}
          </div>
        </Modal>
      </div>
    );
  }
}

SurveySignupModal.propTypes = {
  fromGoogleSSO: PropTypes.bool.isRequired,
  companyLead: CompanyLeadShape.isRequired,
  renderSurvey: PropTypes.bool,
  signupHeaderType: PropTypes.oneOf(['default', 'landingPage', 'referralModal']),
  withIndustryIdentification: PropTypes.bool,
  withRandomizedQuestion: PropTypes.bool,
};

SurveySignupModal.defaultProps = {
  renderSurvey: false,
  signupHeaderType: 'default',
  withIndustryIdentification: false,
  withRandomizedQuestion: false,
};

export default hot(module)(SurveySignupModal);
